import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/zjzs',
  },
  {
    path: '/home',
    component: () => import('@/view/desktop/layout/index.vue'),
    children: [
      {
        path: '/zjzs',
        name: 'zjzs',
        component: () => import("@/view/desktop/index/index.vue")
      },
      {
        path: '/report',
        name: 'Report',
        component: () => import("@/view/desktop/report/index.vue")
      },
      {
        path: '/report/:id',
        name: 'ReportDetail',
        component: () => import("@/view/desktop/reportDetail/index.vue"),
        meta:{}
      },
    ]
  },


]

const router = new VueRouter({
  routes
})

export default router
